import React from 'react';
import { Typography } from 'antd';
import get from 'lodash/get';

const { Text } = Typography;

export const rolesTables = () => [
  {
    title: 'Sr. No.',
    key: 'serial_no',
    className: 'col-index',
    width: 80,
    responsive: ['sm'],
    render: (_, __, index) => <Text>{index + 1}</Text>,
  },
  {
    title: 'Name',
    dataIndex: 'role',
    key: 'role',
    render: (role) => role || '-',
  },
  {
    title: 'Permissions',
    key: 'permissions',
    render: (_, record) => {
      const mappings = get(record, 'role_permission_mappings', []);

      if (!mappings.length) return <Text>-</Text>;

      // Group permissions by group name
      const grouped = mappings.reduce((acc, curr) => {
        const group = curr.permission?.group;
        const permission = curr.permission?.permission;

        if (!group || !permission) return acc;

        acc[group] = acc[group] || [];
        acc[group].push(permission);

        return acc;
      }, {});

      return (
        <>
          {Object.entries(grouped).map(([group, permissions]) => (
            <div key={group}>
              <Text strong>{group}:</Text>{' '}
              <Text>{permissions.join(', ')}</Text>
            </div>
          ))}
        </>
      );
    },
  },
];
